(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hot-main-stage-collection"] && !Shopify.designMode) return;
  try {
    
  class HotMainstageCollection extends HTMLElement {
    connectedCallback() {
      this.launchAt = Date.parse(this.dataset.launchAt);
      if (!Number.isFinite(this.launchAt)) return;

      document.addEventListener('visibilitychange', this.syncLaunch);
      window.addEventListener('pageshow', this.syncLaunch);
      this.syncLaunch();
    }

    disconnectedCallback() {
      clearTimeout(this.launchTimer);
      document.removeEventListener('visibilitychange', this.syncLaunch);
      window.removeEventListener('pageshow', this.syncLaunch);
    }

    syncLaunch = () => {
      clearTimeout(this.launchTimer);
      const remaining = this.launchAt - Date.now();

      if (remaining > 0) {
        this.launchTimer = setTimeout(this.syncLaunch, Math.min(remaining, 2147483647));
        return;
      }

      this.querySelector('[data-launch-note]')?.remove();
      const card = this.querySelector('.hot-mainstage-card');
      if (card) {
        card.href = this.dataset.collectionUrl;
        card.removeAttribute('aria-disabled');
        card.removeAttribute('role');
        card.setAttribute('aria-label', 'Shop Main Stage Collection');
      }
      this.disconnectedCallback();
    };
  }

  if (!customElements.get('hot-mainstage-collection')) {
    customElements.define('hot-mainstage-collection', HotMainstageCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
